import PropTypes from "prop-types";
import { useState } from "react";
import ClickDiv from "./ClickDiv";

function Collapse({
  children,
  title = "Click to expand",
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(() => defaultOpen);

  return (
    <div className="m-2 shadow-sm border-slate-500">
      <ClickDiv
        className="flex cursor-pointer bg-slate-100 hover:bg-slate-400"
        onClick={() => setOpen(!open)}
      >
        <div className="text-lg flex-1 p-3 ">{title}</div>
        <div
          className={`text-lg font-semibold flex-0 p-3 ${
            open ? "rotate-90" : "rotate-270"
          }`}
        >
          &gt;
        </div>
      </ClickDiv>
      <div className={open ? "" : "hidden"}>{children}</div>
    </div>
  );
}

Collapse.propTypes = {
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default Collapse;
